module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapal1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Introduction"
    }
  }, [_vm._v("Introduction and Acknowledgements")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapal"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Chapter01"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "cn-box"
  }, [_vm._v("Chapter 1")])]), _vm._v(" From Soot and Steel")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapal"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter02"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "cn-box"
  }, [_vm._v("Chapter 2")])]), _vm._v(" The North Eastern Railway")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapal"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "cn-box"
  }, [_vm._v("Chapter 3")])]), _vm._v(" The First North Eastern Electric Stock")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapal"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "cn-box"
  }, [_vm._v("Chapter 4")])]), _vm._v(" The Early Years of the Electric Services")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapal"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "cn-box"
  }, [_vm._v("Chapter 5")])]), _vm._v(" The Fire Replacement Stock")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapal"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "cn-box"
  }, [_vm._v("Chapter 6")])]), _vm._v(" The LNER Takes Over")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapal"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "cn-box"
  }, [_vm._v("Chapter 7")])]), _vm._v(" Old Trains, New Route")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapal"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "cn-box"
  }, [_vm._v("Chapter 8")])]), _vm._v(" New Trains, Old Routes")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapal"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "cn-box"
  }, [_vm._v("Chapter 9")])]), _vm._v(" Nationalisation, British Railways")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapal"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "cn-box"
  }, [_vm._v("Chapter 10")])]), _vm._v(" British Railways Electric Stock")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapal"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "cn-box"
  }, [_vm._v("Chapter 11")])]), _vm._v(" The End")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapal"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "cn-box"
  }, [_vm._v("Chapter 12")])]), _vm._v(" The Last Laugh")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapal"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "cn-box"
  }, [_vm._v("Chapter 13")])]), _vm._v(" Metrocars and Beyond")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapal"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "cn-box"
  }, [_vm._v("Chapter 14")])]), _vm._v(" Other North Eastern Railway Electrification Projects")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapal"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Appendix",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "cn-box"
  }, [_vm._v("Appendix")])]), _vm._v(" The Preserved Unit")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapal1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 66
// module chunks = 0